// extracted by mini-css-extract-plugin
export default {"custom-dropdown":"InfoProvider_custom-dropdown__czSVB","item":"InfoProvider_item__MHXEy"};